export const ORGAN_MAP = [
  ["eyes_ears", "Occhi & Orecchie", "Intake", "/intake", "Eye", 35, 7],
  ["brain", "Cervello", "Company Brain", "/brain", "Brain", 54, 7],
  ["mouth", "Bocca", "Marketing & Comunicazione", "/marketing", "Megaphone", 50, 15],
  ["memory", "Memoria", "Archivio & Documenti", "/archive", "Database", 25, 13.5],
  ["nervous_system", "Sistema Nervoso", "Motore di Elaborazione", "/queue", "Cpu", 50, 29.5],
  ["breathing", "Respiro", "Vendite & Operazioni", "/sales", "Wind", 36, 20],
  ["heart", "Cuore", "Finanza & Liquidità", "/finance", "Heart", 47.5, 23],
  ["circulation", "Circolazione", "Contabilità & IVA", "/accounting", "Activity", 60, 26],
  ["immune", "Sistema Immunitario", "Assicurazioni & Compliance", "/compliance", "ShieldAlert", 75, 33],
  ["digestive", "Apparato Digerente", "Acquisti & Fornitori", "/purchases", "Layers", 50, 38],
  ["muscles", "Muscoli", "Personale & Payroll", "/hr", "Users", 25, 33],
  ["skeleton", "Scheletro", "Società & Contratti", "/contracts", "ShieldCheck", 50, 68],
  ["dna", "DNA Aziendale", "Regole & Configurazione", "/dna", "Dna", 14, 52],
].map(([id, anatomy, name, route, icon, x, y]) => ({ id, anatomy, name, route, icon, x, y }));

export const CENSUS_PRESENTATION = {
  NON_ANALIZZATA: ["unknown", "Non ancora analizzata"],
  INCOMPLETA: ["partial", "Incompleta"],
  DOCS_MANCANTI: ["partial", "Documenti mancanti"],
  ANOMALIA: ["error", "Da verificare"],
  CENSITA: ["success", "Censita"],
};
export function organState(organ, requestState) {
  if (requestState === "LOADING") return ["loading", "Caricamento…"];
  if (requestState === "ERROR") return ["error", "Lettura non disponibile"];
  if (!organ) return ["unknown", "Dati insufficienti"];
  return CENSUS_PRESENTATION[organ.census_state] || ["unknown", "Sincronizzazione in corso"];
}
export function coverage(value) {
  return typeof value === "number" && Number.isFinite(value) && value >= 0 && value <= 100 ? value : null;
}
// The legacy endpoint supplies no qualification evidence: never derive business health from coverage.
export function healthState(health) {
  if (!health || !["GREEN", "YELLOW", "RED", "GREY"].includes(health.status)) return ["unknown", "Dati insufficienti"];
  if (health.status === "GREEN") return ["unknown", "Valutazione positiva non qualificata"];
  return { GREEN: ["success", "Sotto controllo"], YELLOW: ["partial", "Richiede attenzione"],
    RED: ["error", "Intervento necessario"], GREY: ["unknown", "Dati insufficienti"] }[health.status];
}

// Touch positions spread distributed systems; the mouth stays on the anatomical face.
export const TOUCH_POSITIONS = {eyes_ears:[28,5],brain:[67,5],mouth:[50,15],memory:[17,16],breathing:[28,26],heart:[50,28],circulation:[74,28],nervous_system:[50,39],digestive:[50,49],muscles:[20,40],immune:[80,40],dna:[16,58],skeleton:[50,70]};
